export default "__VITE_ASSET__e1e92ac8__"